module.exports = __webpack_public_path__ + "img/activate-employee.1122b906.webp";